import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNav from './BottomNav';
import './Auth.css';

const user = {
  name: 'John Doe',
  email: 'john.doe@email.com',
  avatar: 'https://ui-avatars.com/api/?name=John+Doe&background=0074a6&color=fff&size=96',
};

const MyProfile = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    navigate('/login');
  };
  const handleEdit = () => {
    alert('Edit profile feature coming soon!');
  };
  const handleChangePassword = () => {
    alert('Change password feature coming soon!');
  };
  return (
    <div style={{background: '#f6f7fa', minHeight: '100vh', paddingBottom: 80}}>
      {/* Header Bar */}
      <div style={{height: 18}}></div>
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 10px 0 10px', marginBottom: 8}}>
        <span style={{fontSize: 22, color: '#222', fontWeight: 600, flex: 1, textAlign: 'center'}}>My Profile</span>
        <span style={{fontSize: 22, color: '#888', position: 'absolute', right: 18}}>
          <svg width="22" height="22" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>
        </span>
      </div>
      {/* Profile Card */}
      <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 18}}>
        <img src={user.avatar} alt="avatar" style={{width: 92, height: 92, borderRadius: '50%', marginBottom: 10, objectFit: 'cover', boxShadow: '0 2px 8px rgba(0,0,0,0.07)'}} />
        <div style={{fontWeight: 700, fontSize: 21, marginBottom: 2, color: '#222'}}>{user.name}</div>
        <div style={{color: '#555', fontSize: 15, marginBottom: 10}}>{user.email}</div>
        <button className="auth-btn" style={{marginBottom: 8, width: 130, fontSize: 15, padding: '8px 0', borderRadius: 18}} onClick={handleEdit}>Edit Profile</button>
      </div>
      {/* Main Card */}
      <div style={{background: '#fff', borderRadius: 18, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', margin: '0 0 18px 0', padding: '0', maxWidth: 420, marginLeft: 'auto', marginRight: 'auto'}}>
        <ProfileItem icon={<GlobeIcon />} label="Languages" />
        <ProfileItem icon={<PinIcon />} label="Location" />
        <ProfileItem icon={<CardIcon />} label="Subscription" />
      </div>
      <div style={{background: '#fff', borderRadius: 18, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', margin: '0 0 18px 0', padding: '0', maxWidth: 420, marginLeft: 'auto', marginRight: 'auto'}}>
        <ProfileItem icon={<ClockIcon />} label="Clear History" />
        <ProfileItem icon={<ArrowIcon />} label="Log Out" onClick={handleLogout} color="#e74c3c" />
      </div>
      <div style={{textAlign: 'center', color: '#aaa', fontSize: 13, marginTop: 18}}>App Version 2.3</div>
      <BottomNav />
    </div>
  );
};

const ProfileItem = ({ icon, label, onClick, color }) => (
  <div onClick={onClick} style={{display: 'flex', alignItems: 'center', padding: '14px 20px', cursor: onClick ? 'pointer' : 'default', borderBottom: '1px solid #f2f2f2', color: color || '#222'}}>
    <span style={{marginRight: 18, display: 'flex', alignItems: 'center'}}>{icon}</span>
    <span style={{fontSize: 16, flex: 1}}>{label}</span>
    <span style={{color: '#bbb', fontSize: 18}}>&gt;</span>
  </div>
);

// Modern SVG icons
const GlobeIcon = () => (
  <svg width="20" height="20" fill="none" stroke="#0074a6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><ellipse cx="12" cy="12" rx="6" ry="10"/><path d="M2 12h20"/></svg>
);
const PinIcon = () => (
  <svg width="20" height="20" fill="none" stroke="#0074a6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M12 21c-4-4.5-7-7.5-7-11a7 7 0 0 1 14 0c0 3.5-3 6.5-7 11z"/><circle cx="12" cy="10" r="3"/></svg>
);
const CardIcon = () => (
  <svg width="20" height="20" fill="none" stroke="#0074a6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="10" rx="2"/><path d="M2 11h20"/></svg>
);
const ClockIcon = () => (
  <svg width="20" height="20" fill="none" stroke="#0074a6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
);
const ArrowIcon = () => (
  <svg width="20" height="20" fill="none" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M17 16l4-4m0 0l-4-4m4 4H7"/></svg>
);

export default MyProfile; 